import {
    REQUEST_AR,
    FETCH_AR_SUCCESS,
    FETCH_AR_FAILURE,
    CREATE_AR,
    CREATE_AR_SUCCESS,
    CREATE_AR_FAILURE,
    REFUND_AR,
    REFUND_AR_SUCCESS,
    REFUND_AR_FAILURE,
    DELETE_AR,
    DELETE_AR_SUCCESS,
    DELETE_AR_FAILURE,
    EDIT_AR,
    EDIT_AR_SUCCESS,
    EDIT_AR_FAILURE,
    REQUEST_AR_DETAIL,
    FETCH_AR_DETAIL_SUCCESS,
    FETCH_AR_DETAIL_FAILURE,
    CLEAR_AR_DETAIL,
    REQUEST_INVOICES,
    FETCH_INVOICES_SUCCESS,
    FETCH_INVOICES_FAILURE,
    REQUEST_CREDITS,
    FETCH_CREDITS_SUCCESS,
    FETCH_CREDITS_FAILURE,
    CLEAR_CREDITS,
    REQUEST_AR_ACCOUNTS,
    FETCH_AR_ACCOUNTS_SUCCESS,
    FETCH_AR_ACCOUNTS_FAILURE,
    CLEAR_AR_ACCOUNTS,
    CLEAR_AR_FORM,
    BOUNCE_CHECK,
    BOUNCE_CHECK_SUCCESS,
    BOUNCE_CHECK_FAILURE,

    REQUEST_AP,
    FETCH_AP_SUCCESS,
    FETCH_AP_FAILURE,
    CREATE_AP,
    CREATE_AP_SUCCESS,
    CREATE_AP_FAILURE,
    EDIT_AP,
    EDIT_AP_SUCCESS,
    EDIT_AP_FAILURE,
    DELETE_AP,
    DELETE_AP_SUCCESS,
    DELETE_AP_FAILURE,
    REQUEST_AP_DETAIL,
    FETCH_AP_DETAIL_SUCCESS,
    FETCH_AP_DETAIL_FAILURE,
    CLEAR_AP_DETAIL,
    CLEAR_AP_FORM,

    REQUEST_STATEMENT,
    FETCH_STATEMENT_SUCCESS,
    FETCH_STATEMENT_FAILURE,
    REQUEST_STATEMENT_AP,
    FETCH_STATEMENT_AP_SUCCESS,
    FETCH_STATEMENT_AP_FAILURE,
    REQUEST_GENERAL_REPORT,
    FETCH_GENERAL_REPORT_SUCCESS,
    FETCH_GENERAL_REPORT_FAILURE,
    REQUEST_CITY_REPORT,
    FETCH_CITY_REPORT_SUCCESS,
    FETCH_CITY_REPORT_FAILURE,
    RESET_CITY_REPORT,
    REQUEST_CUSTOMER_STATEMENT,
    FETCH_CUSTOMER_STATEMENT_SUCCESS,
    FETCH_CUSTOMER_STATEMENT_FAILURE,
    REQUEST_VENDOR_STATEMENT,
    FETCH_VENDOR_STATEMENT_SUCCESS,
    FETCH_VENDOR_STATEMENT_FAILURE,
    REQUEST_CUSTOMER_STATEMENT_LIST,
    FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS,
    FETCH_CUSTOMER_STATEMENT_LIST_FAILURE,
    REQUEST_VENDOR_STATEMENT_LIST,
    FETCH_VENDOR_STATEMENT_LIST_SUCCESS,
    FETCH_VENDOR_STATEMENT_LIST_FAILURE,
    REQUEST_MOBILE_CUSTOMER_STATEMENT,
    FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS,
    FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE,
    RESET_MOBILE_CUSTOMER_STATEMENT,
} from '../actions/type';

const INITIAL_STATE = {
    ar: null,
    arIsLoading: false,
    arError: null,
    arIsCreating: false,
    arCreateError: null,
    arCreated: false,
    arIsRefunding: false,
    arRefundError: null,
    arRefunded: false,
    arIsEditing: false,
    arEditError: null,
    arEdited: false,
    arIsDeleting: false,
    arDeleteError: null,
    arDeleted: false,
    arDetail: null,
    arDetailError: null,
    arDetailIsLoading: false,
    invoices: null,
    invoicesError: null,
    invoicesIsLoading: false,
    credits: null,
    creditsError: null,
    creditsIsLoading: false,
    bounceCheck: {
      bounceCheck: {},
      bounceCheckError: null,
      bounceCheckIsRequesting: false,
    },
    arAccounts: {
      accountList: [],
      accountsIsLoading: false,
      accountsError: null,
    },

    ap: null,
    apIsLoading: false,
    apError: null,
    apIsCreating: false,
    apCreateError: null,
    apCreated: false,
    apIsEditing: false,
    apEditError: null,
    apEdited: false,
    apIsDeleting: false,
    apDeleteError: null,
    apDeleted: false,
    apDetail: null,
    apDetailError: null,
    apDetailIsLoading: false,
    originalCheckNumber: null,

    statements: null,
    statementsError: null,
    statementsIsLoading: false,
    statementsAP: null,
    statementsAPError: null,
    statementsAPIsLoading: false,
    generalReport: [],
    generalReportIsLoading: false,
    generalReportError: null,
    cityReport: {
      reportData: [],
      cityReportIsLoading: false,
      cityReportError: null,
    },
    customerStatement: [],
    customerStatementIsLoading: false,
    customerStatementError: null,
    customerStatementList: [],
    customerStatementListIsLoading: false,
    customerStatementListError: null,
    vendorStatement: [],
    vendorStatementIsLoading: false,
    vendorStatementError: null,
    vendorStatementList: [],
    vendorStatementListIsLoading: false,
    vendorStatementListError: null,
    mobileCustomerStatement: {
      mobileCustomerStatement: {},
      mobileCustomerStatementIsLoading: false,
      mobileCustomerStatementError: null,
    }
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_AR:
            return { ...state, ar: null, arError: null, arIsLoading: true, arCreated: false, arEdited: false, arDetail: null };
        case FETCH_AR_SUCCESS:// return list of posts and make loading = false
            return { ...state, ar: action.payload.data, arError: null, arIsLoading: false };
        case FETCH_AR_FAILURE:// return error and make loading = false
            const arError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, ar: null, arError: arError, arIsLoading: false };
        case REQUEST_AR_DETAIL:
            return { ...state, arDetail: null, arDetailError: null, arDetailIsLoading: true };
        case FETCH_AR_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, arDetail: action.payload.data, arDetailError: null, arDetailIsLoading: false };
        case FETCH_AR_DETAIL_FAILURE:// return error and make loading = false
            const arDetailError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, arDetail: null, arDetailError: arDetailError, arDetailIsLoading: false };
        case CLEAR_AR_DETAIL:
        case CLEAR_AR_FORM:
            return { ...state, arDetail: null, arDetailError: null, arDetailIsLoading: false };
        case CREATE_AR:
            return { ...state, arIsCreating: true, arCreateError: null, arCreated: false };
        case CREATE_AR_SUCCESS:// return list of posts and make loading = false
            return { ...state, arIsCreating: false, arCreateError: null, arCreated: true };
        case CREATE_AR_FAILURE:// return error and make loading = false
            const arCreateError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            alert(JSON.stringify(arCreateError));
            return { ...state, arIsCreating: false, arCreateError: arCreateError, arCreated: false };
        case REFUND_AR:
            return {
              ...state,
              arIsRefunding: true,
              arRefundError: null,
              arRefunded: false,
            };
        case REFUND_AR_SUCCESS:
            return {
              ...state,
              arIsRefunding: false,
              arRefundError: null,
              arRefunded: true,
            };
        case REFUND_AR_FAILURE: {
            const arRefundError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(arRefundError));
            return {
              ...state,
              arIsRefunding: false,
              arRefundError,
              arRefunded: false,
            };
        }
        case DELETE_AR:
            return { ...state, arIsDeleting: true, arDeleteError: null, arDeleted: false };
        case DELETE_AR_SUCCESS:// return list of posts and make loading = false
            return { ...state, arIsDeleting: false, arDeleteError: null, arDeleted: true };
        case DELETE_AR_FAILURE:// return error and make loading = false
            const arDeleteError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, arIsDeleting: false, arDeleteError: arDeleteError, arDeleted: false };
        case EDIT_AR:
            return { ...state, arIsEditing: true, arEditError: null, arEdited: false };
        case EDIT_AR_SUCCESS:// return list of posts and make loading = false
            return { ...state, arIsEditing: false, arEditError: null, arEdited: true };
        case EDIT_AR_FAILURE:// return error and make loading = false
            const arEditError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            alert(JSON.stringify(arEditError));
            return { ...state, arIsEditing: false, arEditError: arEditError, arEdited: false };
        case BOUNCE_CHECK:
            return {
              ...state,
              bounceCheck: {
                bounceCheck: {},
                bounceCheckError: null,
                bounceCheckIsRequesting: true,
              },
            };
        case BOUNCE_CHECK_SUCCESS:// return list of posts and make loading = false
            alert('Bounced Check Successful');
            return {
              ...state,
              bounceCheck: {
                bounceCheck: action.payload.data,
                bounceCheckError: null,
                bounceCheckIsRequesting: false,
              },
            };
        case BOUNCE_CHECK_FAILURE:// return error and make loading = false
            const bounceCheckError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            alert(JSON.stringify(bounceCheckError));
            return {
              ...state,
              bounceCheck: {
                bounceCheck: {},
                bounceCheckError,
                bounceCheckIsRequesting: true,
              },
            };
        case REQUEST_AR_ACCOUNTS:
            return {
              ...state,
              arAccounts: {
                accountList: [],
                accountListIsLoading: true,
                accountListError: null,
              },
            };
        case FETCH_AR_ACCOUNTS_SUCCESS:
            return {
              ...state,
              arAccounts: {
                accountList: action.payload.data,
                accountListIsLoading: false,
                accountListError: null,
              },
            };
        case FETCH_AR_ACCOUNTS_FAILURE:
            const accountListError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return {
              ...state,
              arAccounts: {
                accountList: [],
                accountListIsLoading: false,
                accountListError,
              },
            };
        case CLEAR_AR_ACCOUNTS:
            return {
              ...state,
              arAccounts: {
                accountList: [],
                accountListIsLoading: false,
                accountListError: null,
              },
            };
        case REQUEST_AP:
            return { ...state, ap: null, apError: null, apIsLoading: true, apCreated: false, apEdited: false, apDetail: null };
        case FETCH_AP_SUCCESS:// return list of posts and make loading = false
            return { ...state, ap: action.payload.data, apError: null, apIsLoading: false };
        case FETCH_AP_FAILURE:// return error and make loading = false
            const apError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, ap: null, apError: apError, apIsLoading: false };
        case REQUEST_AP_DETAIL:
            return { ...state, apDetail: null, apDetailError: null, apDetailIsLoading: true };
        case FETCH_AP_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, apDetail: action.payload.data, apDetailError: null, apDetailIsLoading: false, originalCheckNumber: action.payload.data.CheckNum };
        case FETCH_AP_DETAIL_FAILURE:// return error and make loading = false
            const apDetailError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, apDetail: null, apDetailError: apDetailError, apDetailIsLoading: false };
        case CLEAR_AP_DETAIL:
        case CLEAR_AP_FORM:
            return { ...state, apDetail: null, apDetailError: null, apDetailIsLoading: false };
        case CREATE_AP:
            return { ...state, apIsCreating: true, apCreateError: null, apCreated: false };
        case CREATE_AP_SUCCESS:// return list of posts and make loading = false
            return { ...state, apIsCreating: false, apCreateError: null, apCreated: true };
        case CREATE_AP_FAILURE:// return error and make loading = false
            const apCreateError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            alert(JSON.stringify(apCreateError));
            return { ...state, apIsCreating: false, apCreateError: apCreateError, apCreated: false };
        case DELETE_AP:
            return { ...state, apIsDeleting: true, apDeleteError: null, apDeleted: false };
        case DELETE_AP_SUCCESS:// return list of posts and make loading = false
            return { ...state, apIsDeleting: false, apDeleteError: null, apDeleted: true };
        case DELETE_AP_FAILURE:// return error and make loading = false
            const apDeleteError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, apIsDeleting: false, apDeleteError: apDeleteError, apDeleted: false };
        case EDIT_AP:
            return { ...state, apIsEditing: true, apEditError: null, apEdited: false };
        case EDIT_AP_SUCCESS:// return list of posts and make loading = false
            return { ...state, apIsEditing: false, apEditError: null, apEdited: true };
        case EDIT_AP_FAILURE:// return error and make loading = false
            const apEditError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            alert(JSON.stringify(apEditError));
            return { ...state, apIsEditing: false, apEditError: apEditError, apEdited: false };

        case REQUEST_INVOICES:
            return { ...state, invoices: null, invoicesError: null, invoicesIsLoading: true };
        case FETCH_INVOICES_SUCCESS:// return list of posts and make loading = false
            return { ...state, invoices: action.payload.data, invoicesError: null, invoicesIsLoading: false };
        case FETCH_INVOICES_FAILURE:// return error and make loading = false
            const invoicesError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, invoices: null, invoicesError: invoicesError, invoicesIsLoading: false };
        case REQUEST_CREDITS:
            return { ...state, credits: null, creditsError: null, creditsIsLoading: true };
        case FETCH_CREDITS_SUCCESS:// return list of posts and make loading = false
            return { ...state, credits: action.payload.data, creditsError: null, creditsIsLoading: false };
        case FETCH_CREDITS_FAILURE:// return error and make loading = false
            const creditsError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, credits: null, creditsError: creditsError, creditsIsLoading: false };
        case CLEAR_CREDITS:
            return { ...state, credits: null, creditsError: null, creditsIsLoading: false };
        case REQUEST_STATEMENT:
            return { ...state, statements: [], statementsError: null, statementsIsLoading: true };
        case FETCH_STATEMENT_SUCCESS:// return list of posts and make loading = false
            return { ...state, statements: action.payload.data, statementsError: null, statementsIsLoading: false };
        case FETCH_STATEMENT_FAILURE:// return error and make loading = false
            const statementsError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, statements: [], statementsError: statementsError, statementsIsLoading: false };

        case REQUEST_STATEMENT_AP:
            return { ...state, statementsAP: [], statementsAPError: null, statementsAPIsLoading: true };
        case FETCH_STATEMENT_AP_SUCCESS:// return list of posts and make loading = false
            return { ...state, statementsAP: action.payload.data, statementsAPError: null, statementsAPIsLoading: false };
        case FETCH_STATEMENT_AP_FAILURE:// return error and make loading = false
            const statementsAPError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, statementsAP: [], statementsAPError: statementsAPError, statementsAPIsLoading: false };

        case REQUEST_GENERAL_REPORT:
            return { ...state, generalReport: [], generalReportError: null, generalReportIsLoading: true };
        case FETCH_GENERAL_REPORT_SUCCESS:// return list of posts and make loading = false
            return { ...state, generalReport: action.payload.data, generalReportError: null, generalReportIsLoading: false };
        case FETCH_GENERAL_REPORT_FAILURE:// return error and make loading = false
            const generalReportError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, generalReport: [], generalReportError: generalReportError, generalReportIsLoading: false };

        case REQUEST_CITY_REPORT:
            return {
              ...state,
              cityReport: {
                reportData: [],
                cityReportIsLoading: true,
                cityReportError: null,
              },
            };
        case FETCH_CITY_REPORT_SUCCESS:
            return {
              ...state,
              cityReport: {
                reportData: action.payload.data,
                cityReportIsLoading: false,
                cityReportError: null,
              },
            };
        case FETCH_CITY_REPORT_FAILURE:
          const cityReportError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return {
              ...state,
              cityReport: {
                reportData: [],
                cityReportIsLoading: false,
                cityReportError,
              },
            };
        case RESET_CITY_REPORT:
          return {
            ...state,
            cityReport: {
              reportData: [],
              cityReportIsLoading: false,
              cityReportError: null,
            },
          };

        case REQUEST_CUSTOMER_STATEMENT:
            return { ...state, customerStatement: [], customerStatementError: null, customerStatementIsLoading: true };
        case FETCH_CUSTOMER_STATEMENT_SUCCESS:// return list of posts and make loading = false
            return { ...state, customerStatement: action.payload.data, customerStatementError: null, customerStatementIsLoading: false };
        case FETCH_CUSTOMER_STATEMENT_FAILURE:// return error and make loading = false
            const customerStatementError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, customerStatement: [], customerStatementError: customerStatementError, customerStatementIsLoading: false };
        case REQUEST_VENDOR_STATEMENT:
            return { ...state, vendorStatement: [], vendorStatementError: null, vendorStatementIsLoading: true };
        case FETCH_VENDOR_STATEMENT_SUCCESS:// return list of posts and make loading = false
            return { ...state, vendorStatement: action.payload.data, vendorStatementError: null, vendorStatementIsLoading: false };
        case FETCH_VENDOR_STATEMENT_FAILURE:// return error and make loading = false
            const vendorStatementError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, vendorStatement: [], vendorStatementError: vendorStatementError, vendorStatementIsLoading: false };
        case REQUEST_CUSTOMER_STATEMENT_LIST:
            return { ...state, customerStatementList: [], customerStatementListError: null, customerStatementListIsLoading: true };
        case FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS:// return list of posts and make loading = false
            return { ...state, customerStatementList: action.payload.data, customerStatementListError: null, customerStatementListIsLoading: false };
        case FETCH_CUSTOMER_STATEMENT_LIST_FAILURE:// return error and make loading = false
            const customerStatementListError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, customerStatementList: [], customerStatementListError: customerStatementListError, customerStatementListIsLoading: false };
        case REQUEST_VENDOR_STATEMENT_LIST:
            return { ...state, vendorStatementList: [], vendorStatementListError: null, vendorStatementListIsLoading: true };
        case FETCH_VENDOR_STATEMENT_LIST_SUCCESS:// return list of posts and make loading = false
            return { ...state, vendorStatementList: action.payload.data, vendorStatementListError: null, vendorStatementListIsLoading: false };
        case FETCH_VENDOR_STATEMENT_LIST_FAILURE:// return error and make loading = false
            const vendorStatementListError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, vendorStatementList: [], vendorStatementListError: vendorStatementListError, vendorStatementListIsLoading: false };
        case REQUEST_MOBILE_CUSTOMER_STATEMENT:
            return {
              ...state,
              mobileCustomerStatement: {
                mobileCustomerStatement: {},
                mobileCustomerStatementError: null,
                mobileCustomerStatementIsLoading: true,
              },
            };
        case FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS:// return list of posts and make loading = false
            return {
              ...state,
              mobileCustomerStatement: {
                mobileCustomerStatement: action.payload.data,
                mobileCustomerStatementError: null,
                mobileCustomerStatementIsLoading: false,
              },
            };
        case FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE:// return error and make loading = false
            return {
              ...state,
              mobileCustomerStatement: {
                mobileCustomerStatement: {},
                mobileCustomerStatementError: action.payload.data || { message: action.payload.message },
                mobileCustomerStatementIsLoading: false,
              },
            };
        case RESET_MOBILE_CUSTOMER_STATEMENT:
            return {
              ...state,
              mobileCustomerStatement: {
                mobileCustomerStatement: {},
                mobileCustomerStatementError: null,
                mobileCustomerStatementIsLoading: false,
              },
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/arap_reducer.jsx